<template>
  <v-card class="pt-5" elevation="0">
    <loading-block v-if="!loaded"></loading-block>
    <v-form ref="updateForm" lazy-validation v-else>
      <v-layout row wrap>
        <v-flex sm12 md3 xs12 px-3>
          <v-text-field
            v-model="form.thc"
            :rules="deciNumericValidation"
            name="THC"
            label="THC"
            required
            validate-on-blur
            type="number"
          ></v-text-field>
        </v-flex>
        <v-flex sm12 md3 xs12 px-3>
          <v-text-field
            v-model="form.thc_min"
            :rules="deciNumericValidation"
            name="THC min"
            label="THC min"
            required
            validate-on-blur
            type="number"
          ></v-text-field>
        </v-flex>
        <v-flex sm12 md3 xs12 px-3>
          <v-text-field
            v-model="form.thc_max"
            :rules="deciNumericValidation"
            name="THC max"
            label="THC max"
            required
            validate-on-blur
            type="text"
          ></v-text-field>
        </v-flex>

        <v-flex sm12 md3 xs12 px-3>
          <v-select
            v-model="form.thc_level"
            :items="[
                {
                  text: 'Low',
                  value: 'low'
                },
                {
                  text: 'Medium',
                  value: 'medium'
                },
                {
                  text: 'High',
                  value: 'high'
                }
              ]"
            label="THC level"
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex sm12 md3 xs12 px-3>
          <v-text-field
            v-model="form.cbd"
            :rules="deciNumericValidation"
            name="CBD"
            label="CBD"
            required
            validate-on-blur
            type="text"
          ></v-text-field>
        </v-flex>
        <v-flex sm12 md3 xs12 px-3>
          <v-text-field
            v-model="form.cbd_min"
            :rules="deciNumericValidation"
            name="CBD min"
            label="CBD min"
            required
            validate-on-blur
            type="text"
          ></v-text-field>
        </v-flex>
        <v-flex sm12 md3 xs12 px-3>
          <v-text-field
            v-model="form.cbd_max"
            :rules="deciNumericValidation"
            name="CBD max"
            label="CBD max"
            required
            validate-on-blur
            type="text"
          ></v-text-field>
        </v-flex>
        <v-flex sm12 md3 xs12 px-3>
          <v-select
            v-model="form.cbd_level"
            :items="[
                {
                  text: 'Low',
                  value: 'low'
                },
                {
                  text: 'Medium',
                  value: 'medium'
                },
                {
                  text: 'High',
                  value: 'high'
                }
              ]"
            label="CBD level"
          ></v-select>
        </v-flex>
      </v-layout>

      <v-layout row>
        <v-flex sm12 px-3>
          <v-select
            v-model="form.concentration_unit"
            :rules="normalValidation"
            :items="[
            {
              text: 'Mg/ml',
              value: 'mg/ml',
            },
            {
              text: '%',
              value: '%',
            },
            {
              text: 'Mg/g',
              value: 'mg/g',
            },
            {
              text: 'Mg',
              value: 'mg',
            },
            {
              text: 'Ml',
              value: 'ml',
            }
          ]"
            label="Concentration unit"
          ></v-select>
        </v-flex>
      </v-layout>
    </v-form>

    <div class="mb-5 text-right" v-if="loaded">
      <template v-if="type=='add'">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              @click="add()"
              v-on="on"
              small
              dark
              color="primary"
              :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-0' : 'ml-0 mr-3'"
              depressed
            >Add</v-btn>
          </template>
          <span>Add</span>
        </v-tooltip>
      </template>

      <template v-else>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              @click="update()"
              v-on="on"
              small
              dark
              color="primary"
              :class="$vuetify.breakpoint.width > 960 ? 'ml-0 mr-3' : 'ml-0 mr-3'"
              depressed
            >Edit</v-btn>
          </template>
          <span>Update</span>
        </v-tooltip>

        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn @click="deleteCbdLevel()" v-on="on" small dark color="primary" depressed>Delete</v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
    </div>
  </v-card>
</template>

<script>
import { ProductAPI } from '@/clients/product/product.api'
import LoadingBlock from '@/components/custom-components/LoadingBlock.vue'
import { mapActions, mapGetters } from 'vuex'
import _ from 'lodash'

export default {
  components: {
    LoadingBlock
  },
  data() {
    return {
      normalValidation: [
        v => !!v || 'Field is required'
      ],
      textValidation: [
        v => !!v.replace(/\s/g, '') || 'Field is required'
      ],
      deciNumericValidation: [
        (v) => !!v || v === 0 || 'Field is required',
        (v) => /^\d+(\.\d{1,2})?$/.test(v) || 'Field must be numeric'
      ],
      type: 'add',
      form: {
        id: '',
        product_id: '',
        thc: '',
        thc_min: '',
        thc_max: '',
        thc_level: '',
        cbd: '',
        cbd_min: '',
        cbd_max: '',
        cbd_level: '',
        concentration_unit: ''
      },
      loaded: false
    }
  },
  computed: {
    ...mapGetters({
      activeItem: 'product/activeItem'
    })
  },
  watch: {

  },
  mounted() {
    if (!_.isEmpty(this.activeItem)) {
      this.getProductCbdLevel()
    }
  },
  methods: {
    /**
     * Get value
     */
    async getProductCbdLevel() {
      try {
        this.loaded = false
        let res = await ProductAPI.fetchCBDTHC(this.activeItem.id)
        this.loaded = true
        this.type = 'delete' // we dont have update mode;
        for (let key in this.form) {
          this.form[key] = res.data.payload[key]
        }
      } catch (err) {
        this.loaded = true
        this.type = 'add'
      }
    },

    /**
     * Add
     */
    async add() {
      if (this.$refs['updateForm'].validate()) {
        try {
          this.form.product_id = this.activeItem.id
          // Trigger api
          this.spinner(true)
          let res = await ProductAPI.insertCBDTHC(this.form)
          this.spinner(false)
          if (res.status === 200) {
            for (let key in this.form) {
            this.form[key] = res.data.payload[key]
          }
            this.type = 'delete'
          }
          // Display message alert
          this.snackbar({
            text: res.status === 200 ? res.data.msg : res.response.data.errors ? res.response.data.errors[0] : res.response.data.msg,
            open: true,
            color: res.status === 200 ? 'success' : 'error'
          })
        } catch (err) {
          this.spinner(false)
          this.snackbar({
            text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
            open: true,
            color: 'error'
          })
        }
      }
    },

    /**
     * Update
     */

    async update() {
      if (this.$refs['updateForm'].validate()) {
        try {
          this.form.product_id = this.activeItem.id

          // Trigger apis
          this.spinner(true)
          let res = await ProductAPI.editCBDTHC(this.form.id, this.form)
          this.spinner(false)
          // Display message alert
          this.snackbar({
            text: res.status === 200 ? res.data.msg : res.response.data.errors ? res.response.data.errors[0] : res.response.data.msg,
            open: true,
            color: res.status === 200 ? 'success' : 'error'
          })
        } catch (err) {
          this.spinner(false)
          this.snackbar({
            text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
            open: true,
            color: 'error'
          })
        }
      }
    },

    /**
     * Delete
     */
    deleteCbdLevel() {
      const self = this
      this.$swal({
        title: 'Are you sure?',
        type: 'warning',
        html: `You are about to delete ${self.activeItem.name} CBD Level.`,
        showCloseButton: false,
        showCancelButton: true,
        focusConfirm: false,
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel',
        buttonsStyling: false,
        customClass: {
          container: 'custom-swal'
        }
      }).then(async function (result) {
        if (result.value) {
          try {
            self.spinner(true)
            let res = await ProductAPI.deleteCBDTHC(self.form.id)
            self.spinner(false)
            if (res.status === 200) {
              self.form.id = ''
              self.$refs['updateForm'].reset()
              self.type = 'add'
              self.$swal(
                'Deleted!',
                `Successfully deleted.`,
                'success'
              )
            } else {
              self.$swal(
                'Failed!',
                'Please try again later.',
                'error'
              )
            }
          } catch (err) {
            self.spinner(false)
            self.snackbar({
              text: err.response.data.errors ? err.response.data.errors[0] : err.response.data.message,
              open: true,
              color: 'error'
            })
          }
        }
      })
    },
    ...mapActions({
    })
  }
}
</script>
